import React from 'react';
import { useAppSelector } from 'hooks';
import { Col, Row } from 'reactstrap';
import classNames from 'classnames';

import { formatDuration } from '~libs/dayjs';
import { Event, getEventTotalsRange, Worker } from '~weekly-planner/lib/common';

import Icon, { faTriangleExclamation } from '~components/icon';

import { selectAll } from '~weekly-planner/selectors/appointments/awardAlerts';

import TooltipPortal from '../TooltipPortal';

interface ComponentProps {
  worker: Worker;
  events: Event[];
  className?: string;
}

const WorkerAlerts: React.FC<ComponentProps> = ({ worker, events = [], className }) => {
  let hasAlert = false;

  const userAlerts = useAppSelector(selectAll).filter((award) => award.user.id === worker.id);

  const alert = userAlerts
    .filter(({ tag }) => tag === 'min-hours' || tag === 'max-hours')
    .map(({ tag, user }) => {
      hasAlert = true;
      const duration = getEventTotalsRange(events, 'predicted');
      return {
        caption: tag === 'min-hours' ? `Min: ${user.hours_min}h` : `Max: ${user.hours_max}h`,
        tooltip: `Current Hours: ${formatDuration(Number(duration))}`,
      };
    });

  const cellClassName = classNames('award-alert', [className]);
  const renderAlerts = () =>
    alert.map(({ caption, tooltip }, index) => (
      <div className="row alert-label" key={index} id={`alert-${worker.id}-${index}`}>
        <Col className="text-start">{caption}</Col>
        <Col sm={2} className="text-center">
          <Icon className="alert-icon" icon={faTriangleExclamation} />
        </Col>
        <TooltipPortal targetId={`alert-${worker.id}-${index}`} content={tooltip} placement="right" />
      </div>
    ));

  return hasAlert ? <Row className={cellClassName}>{renderAlerts()}</Row> : <></>;
};

export default WorkerAlerts;
